/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Integration config
 */
import _ from 'lodash';
import { getRealmName } from '@veritable/common/utils';
import Environment from '@veritable/common/utils/environment';
import { MARKER_IO_PRODUCTION_PROJECT_ID, POSTHOG_UI_HOST, POST_HOG_PRODUCTION_API_KEY } from './url';
import { maskText, POSTHOG_EVENTS_TO_BLOCK } from 'utils/configUtils';

const { clientURL, authURL, accountsURL, posthogURL } = Environment.getHostNames('production');

/**
 * Production config
 */
const config: EnvConfig = {
	keycloak: {
		config: {
			realm: getRealmName(),
			url: authURL,
			clientId: 'veritable',
		},
		initOptions: {
			onLoad: 'login-required',
			checkLoginIframe: false,
			token: '',
			enableLogging: true,
		},
		loginOptions: {
			loginHint: Environment.getLoginHint(),
		},
	},
	markerIO: {
		disabled: false,
		project: MARKER_IO_PRODUCTION_PROJECT_ID,
	},
	postHog: {
		apiKey: POST_HOG_PRODUCTION_API_KEY,
		config: {
			api_host: posthogURL,
			ui_host: POSTHOG_UI_HOST,
			autocapture: false,
			capture_pageview: false,
			capture_exceptions: {
				capture_console_errors: true,
				capture_unhandled_rejections: true,
				capture_unhandled_errors: true,
			},
			before_send: (cr) => (!_.includes(POSTHOG_EVENTS_TO_BLOCK, cr?.event) ? cr : null),
			session_recording: {
				maskAllInputs: true,
				maskTextSelector: '*',
				maskInputFn: maskText,
				maskTextFn: maskText,
			},
		},
	},
	client: {
		baseURL: clientURL,
	},
	accountsClient: {
		baseURL: accountsURL,
	},
	accessibilityAudit: {
		enabled: false,
	},
};

export default config;
